import React from "react";
import { Container } from "reactstrap";
import Breadcrumb from "../../components/common/Breadcrumb";
import MetaTag from "../../components/common/MetaTagSeo";
import { LoanRequestPage } from "../../constant/SCO_Name";
import { LoanRequestRoute } from "../../constant/RouteName";
import useFetch from "../../hooks/useFetch";
import { ServerError } from "../../constant/NotifyMessage";
import Loading from "../../components/helper/Loading";
import { useStore1Selector } from "index";
import { loginUser } from "../../Redux/Slices/userSlice";
import SmallModal from "../../components/common/SmallModal";
import Modal from "../../sections/Admin/debt-collection/UpdateAmount";
import { BsEyeFill } from "react-icons/bs";
import ModalComp from "../../components/common/Modal";
import ErrorPage from "../../components/helper/ErrorPage";
import { Badge } from "react-bootstrap";
import usePost from "../../hooks/usePost";
import LoadingAnimation from "../../components/helper/Loading-animation";
import ViewLoan from "../../components/views/ViewLoan";
import { debCollectionColumns } from "../../constant/Columns";
import Table from "../../components/common/Table";
import { formatDate } from "../../utils/dateFormat";

const DebtCollection = () => {
  const userDet = useStore1Selector(loginUser);
  const token = userDet?.token;
  const res_data = [];

  const { execute, pending } = usePost()

  const { data, loading, error, reFetch } = useFetch(
    `${process.env.REACT_APP_BACKEND_URL}/loans/debt?status=debtCollection&sort=-createdAt`,
    token
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [status, setStatus] = React.useState();
  const [loanId, setLoanId] = React.useState();
  const [btnName, setBtnName] = React.useState();
  const [viewUserDet, setViewUserDet] = React.useState(false);

  if (loading) return <LoadingAnimation />

  if (error) return <ErrorPage message={ServerError} />;

  const updatePayment = (id) => {
    setOpenModal(true);
    setStatus("verification");
    setLoanId(id);
    setBtnName("Verification");
  };

  const viewDetails = (id) => {
    setViewUserDet(true);
    setLoanId(id);
  };

  const sendToManagement = (id) => {
    const Method = 'PATCH', endPoint = `loans/${id}/debt-collector`;
    const raw = JSON.stringify({
      status: "debt-collector",
      debtCollector: true
    });
    execute(endPoint, raw, Method, "Successfully sent", token)
  };

  if (pending) {
    setTimeout(() => {
      reFetch();
    }, 2000);
  }

  const filterArr = () => {
    data?.forEach((res) => {
      res_data.push({
        ...res,
        firstName: res?.user?.firstName,
        lastName: res?.user?.lastName,
        payment_Date: formatDate(res?.paymentDate),
        debt_start_date: formatDate(res?.debtStatus?.startDate),
        debt_weekly_duration: (
          <Badge variant="danger" className="p-2">
            {`${res?.debtStatus?.week} week${res?.debtStatus?.week === 1 ? "" : "s"
              }`}{" "}
          </Badge>
        ),
        image: (
          <img
            src={`${process.env.REACT_APP_IMG_API}${res?.user?.photoProfile}`}
            alt=""
            width={50}
            height={40}
          />
        ),
        viewBtn: (
          <button
            className="btn btn__table  color__blue"
            onClick={() => viewDetails(res?._id)}
          >
            <BsEyeFill size={14} /> View{" "}
          </button>
        ),
        verifyBtn: (
          <button
            className="btn btn__table color__verify"
            onClick={() => updatePayment(res?._id)}
          >
            Update to paid
          </button>
        ),
        mngtBtn: (
          <button className="btn btn__table color__green" onClick={() => sendToManagement(res?._id)}>

            {pending ? "Loading..." : " Send to management"}
          </button>
        ),
      });
    });
  };
  filterArr();

  return (
    <React.Fragment>
      <div className="page-content px-5">
        <Breadcrumb
          default={LoanRequestRoute}
          defaultName="Debt collections"
          title={"Debt"}
        />
        <MetaTag title_sco={LoanRequestPage} />

        <Container fluid>
          <div className="page-title-box">
            {loading ? <Loading /> : <Table columns={debCollectionColumns} data={res_data} />}
          </div>
        </Container>
      </div>

      <ModalComp
        ModalTitle=""
        open={viewUserDet}
        onClose={() => setViewUserDet(false)}
        cancel="close"
        Component={
          <ViewLoan onClose={() => setViewUserDet(false)} loan_Id={loanId} />
        }
      />

      <SmallModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        ModalTitle=""
        cancel="close"
        Components={
          <Modal
            reFetch={reFetch}
            onClose={() => setOpenModal(false)}
            status={status}
            loanId={loanId}
            btnName={btnName}
          />
        }
      />
    </React.Fragment>
  );
};
export default DebtCollection;
